export const statusColorMap: Record<string, { class: string; text: string }> = {
  submitted: { class: 'bg-gray-200', text: 'Submitted' },
  paid: { class: 'bg-red-200', text: 'Paid' },
  items_purchased: { class: 'bg-orange-200', text: 'Items Purchased' },
  ready_for_collection: { class: 'bg-yellow-200', text: 'Ready for Collection' },
  collected: { class: 'bg-green-200', text: 'Collected' },
  cancelled: { class: 'bg-purple-200', text: 'Cancelled' },
};
